export const SkeletonDashboard = () => {
  return (
    <div className="p-[1rem] mx-[2.5rem] mb-[1rem]  max-h-full max-w-full">
      <div className="bg-white h-[5rem] animate-pulse "> </div>
      <div className="flex flex-row mt-[1rem] space-x-[1rem]   ">
        <div className=" basis-5/6 grid grid-cols-3 gap-[1rem] grid-flow-dense     ">
          <div className=" col-span-3 bg-white animate-pulse   "></div>

          <div className="col-span-2  bg-white animate-pulse "></div>
          <div className="col-span-1">
            <div className="h-full bg-white  animate-pulse "></div>
          </div>

          <div className="bg-white  col-span-2 animate-pulse "></div>

          <div className="bg-white  animate-pulse col-span-1 overflow"></div>
        </div>
        <div className=" flex basis-1/6 flex-col justify-between row-span-3 overflow-auto  ">
          <div className=" bg-white  animate-pulse h-[77vh]"></div>
        </div>
      </div>
    </div>
  );
};
